export default defineNuxtRouteMiddleware(() => {
  const { cancelAllRequests } = useAbortController()

  // Cancel all ongoing API requests when navigating away from the current route
  cancelAllRequests()
})
